module.exports = __webpack_public_path__ + "media/images/ceremony/top/reason2-afde27c9cd4c21822a3f55b5574189d1.jpg";